import React from 'react';
import { Button, Col, ListGroup, Row } from 'react-bootstrap';

const Pagination = ({
	previousPage,
	pageCount,
	pageIndex,
	gotoPage,
	nextPage
}) => {
	// Determines which pages to show in the pagination bar
	const getPaginationGroup = () => {
		let start, end;
		if (pageCount <= 5) {
			// Moins de 5 pages totales, affichez-les toutes
			start = 1;
			end = pageCount;
		} else {
			// Plus de 5 pages
			if (pageIndex <= 2) {
				// Si près du début
				start = 1;
				end = 3;
			} else if (pageIndex >= pageCount - 3) {
				// Si près de la fin
				start = pageCount - 2;
				end = pageCount;
			} else {
				// Autour de la page actuelle
				start = pageIndex;
				end = pageIndex + 2;
			}
		}

		const group = [];
		if (start > 2) group.push('...');
		for (let i = start; i <= end; i++) {
			group.push(i);
		}
		if (end < pageCount - 1) group.push('...');

		return group;
	};

	return (
		<Row>
			<Col lg={12} md={12} sm={12}>
				<div className="pb-5">
					<nav>
						<ListGroup
							as="ul"
							bsPrefix="pagination"
							className="justify-content-center mb-0"
						>
							<ListGroup.Item as="li" bsPrefix="page-item">
								<Button
									onClick={() => previousPage()}
									className="page-link mx-1 rounded"
									disabled={pageIndex === 0}
								>
									<i className="fa-solid fa-chevron-left"></i>
								</Button>
							</ListGroup.Item>

							{getPaginationGroup().map((item, index) => {
								return item === '...' ? (
									<ListGroup.Item as="li" bsPrefix="page-item" key={index}>
										<span className="page-link mx-1 rounded">{item}</span>
									</ListGroup.Item>
								) : (
									<ListGroup.Item
										as="li"
										bsPrefix="page-item"
										key={index}
										className={`page-item ${
											pageIndex === item - 1 ? 'active' : ''
										}`}
									>
										<Button
											className="page-link mx-1 rounded"
											onClick={() => gotoPage(item - 1)}
										>
											{item}
										</Button>
									</ListGroup.Item>
								);
							})}

							<ListGroup.Item as="li" bsPrefix="page-item">
								<Button
									onClick={() => nextPage()}
									className="page-link mx-1 rounded"
									disabled={pageIndex === pageCount - 1}
								>
									<i className="fa-solid fa-chevron-right"></i>
								</Button>
							</ListGroup.Item>
						</ListGroup>
					</nav>
				</div>
			</Col>
		</Row>
	);
};

export default Pagination;
